import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  useTheme,
} from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsIcon from '@mui/icons-material/Settings';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme as useAppTheme } from '../ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import logo from '../2024-header-logos-001upload.png';

const Header = () => {
  const theme = useTheme();
  const { mode, toggleTheme } = useAppTheme();
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleTestDashboard = () => {
    navigate('/test-dashboard');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleLogoClick}>
          <img
            src={logo}
            alt="FreeWeb3 Logo"
            style={{
              height: '48px',
              marginRight: theme.spacing(2),
              borderRadius: '4px',
            }}
          />
          <Typography
            variant="h6"
            component="h1"
            sx={{
              color: 'text.primary',
              fontWeight: 600,
              display: { xs: 'none', sm: 'block' }
            }}
          >
            Secure File Upload
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {isAuthenticated && user && (
            <Typography variant="body2" sx={{ mr: 1, display: { xs: 'none', sm: 'block' } }}>
              {user.username}
            </Typography>
          )}

          <IconButton
            onClick={handleTestDashboard}
            color="primary"
            aria-label="Test Dashboard"
            sx={{
              bgcolor: location.pathname === '/test-dashboard' ? 'action.selected' : 'transparent'
            }}
          >
            <SettingsIcon />
          </IconButton>

          {isAuthenticated ? (
            <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              size="small"
            >
              Logout
            </Button>
          ) : (
            <Button
              variant="contained"
              startIcon={<LoginIcon />}
              onClick={handleLogin}
              size="small"
            >
              Login
            </Button>
          )}

          <IconButton
            onClick={toggleTheme}
            color="primary"
            aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;